import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from "rxjs";
import { MsalService } from '@azure/msal-angular';
import { environment } from 'src/environments/environment';
import { AuthenticationService } from 'src/services/authentication/authentication.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(
    private msalService: MsalService,
    private authenticationService: AuthenticationService){
  }

 intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
  let account = this.msalService.instance.getActiveAccount();

  if (account != null && account.tenantId === environment.msalConfigB2C.tenantId) {
    const accountType = this.authenticationService.getAccountType().toString();
    const companyId = this.authenticationService.getCompanyId().toString();

    const authorizedRequest = req.clone({
      headers: req.headers
        .set('tql-identity-accounttype', accountType)
        .set('tql-identity-companyid', companyId)
    });
    return next.handle(authorizedRequest);
  }
  
   return next.handle(req);
 }
}